module.exports = __webpack_public_path__ + "img/dots-right.0003662a.png";